<template functional>
  <AMenuItem v-if="!props.item.subMenu" :key="props.item.id" :title="!props.item.parentMenu.length && props.item.name">
    <MenuContent :item="props.item" :is-collapsed="props.isCollapsed" />
  </AMenuItem>
</template>

<script>
import MenuContent from './menu-content'

export default {
  name: 'BaseMenuItem',

  components: {
    MenuContent,
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
